import { render, staticRenderFns } from "./Check.vue?vue&type=template&id=03ac3446&scoped=true&"
import script from "./Check.vue?vue&type=script&lang=ts&"
export * from "./Check.vue?vue&type=script&lang=ts&"
import style0 from "./Check.vue?vue&type=style&index=0&id=03ac3446&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ac3446",
  null
  
)

export default component.exports